import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./userJoinedChatSuccessPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { useNavigate } from "react-router-dom";

function UserJoinedChatSuccessPopup({
  userName,
  onClose,
}: IPopupWithoutProps & { userName: string }) {
  const navigate = useNavigate();
  return (
    <article className={popupStyles.popup}>
      <h2 className={popupStyles.popup__title}>{t("USER_JOINED_CHAT_SUCCESS_TITLE")} {userName}</h2>
      <img
        src={doctor}
        alt={t("IMAGE_ALT_VENCHY_DOCTOR")}
        className={popupStyles.popup__img}
      />
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={() => {
          onClose();
          navigate("/messages");
        }}
      >
         {t("USER_JOINED_CHAT_SUCCESS_BUTTON")}
      </button>
    </article>
  );
}

export default UserJoinedChatSuccessPopup;
